import { Command } from '@ckeditor/ckeditor5-core';
import { openRecorderModal } from './modal/openrecordermodal'; // ⬅ tu modal
import RecorderUtils from './recorderutils';

export default class RecorderVideoCommand extends Command {
    refresh() {
        const recorderUtils = this.editor.plugins.get(RecorderUtils);
        this.isEnabled = recorderUtils.isRecorderAllowed();
    }

execute() {
    const editor = this.editor;
    const recorderUtils = editor.plugins.get(RecorderUtils);
    const fpoptions = editor.config.get('fpoptions') || {};

    openRecorderModal(
        'video',
            url => {
                editor.model.change(() => {
                    recorderUtils.insertRecorder({
                        type: 'video',
                        src: url,
                        alignment: 'center'
                    });
                });
            },
            editor,
            fpoptions
        );
    }
}
